import axios from 'axios';
import { config } from 'config';

const AXIOS_OPTIONS = {
    headers: {
        'Content-Type': 'application/json',
    }
}

const plainAxios = axios.create({
    ...AXIOS_OPTIONS
})


const serverAxios = axios.create({
    baseURL: config.API_URL,
    // withCredentials: true,
    ...AXIOS_OPTIONS
});

// Request interceptor to append language param for safetynow endpoints
// and ensure auth token is always present if user is logged in
serverAxios.interceptors.request.use((req) => {
    try {
        // Add language parameter for safetynow endpoints
        const selectedLang = localStorage.getItem('language');
        if (selectedLang && req.url && req.url.includes('/safetynow') && !req.url.includes('lang=')) {
            const separator = req.url.includes('?') ? '&' : '?';
            req.url = `${req.url}${separator}lang=${selectedLang}`;
        }
        
        // Ensure auth token is present - fallback to localStorage if not set in defaults
        if (!req.headers.Authorization) {
            const token = localStorage.getItem('token');
            if (token) {
                req.headers.Authorization = `Bearer ${token}`;
            }
        }
    } catch (e) {
        // ignore
    }
    return req;
}, (error) => Promise.reject(error));


// Helper to set the Authorization header globally
export function setAxiosAuthToken(token) {
    if (token) {
        serverAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete serverAxios.defaults.headers.common['Authorization'];
    }
}

export {
    plainAxios as defaultAxios,
    serverAxios as axios,
}
